import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    isDevMode,
    provideAppInitializer,
    provideCheckNoChangesConfig,
    provideZoneChangeDetection,
} from "@angular/core";
import {
    NavigationStart,
    provideRouter,
    Router,
    TitleStrategy,
    withInMemoryScrolling,
} from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";

import { routes } from "./app.routes";
import { provideClientHydration, withEventReplay } from "@angular/platform-browser";
import { icons } from "./icons-provider";
import { provideNzIcons } from "ng-zorro-antd/icon";
import { en_US, NZ_DATE_CONFIG, provideNzI18n, ro_RO, ru_RU } from "ng-zorro-antd/i18n";
import { registerLocaleData } from "@angular/common";
import en from "@angular/common/locales/en";
import ru from "@angular/common/locales/ru";
import ro from "@angular/common/locales/ro";
import { FormsModule } from "@angular/forms";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { httpRequestInterceptor } from "#src/app/core/interceptors/http.interceptor";
import { TranslatePipe } from "#pipes/i18n/translate.pipe";
import { SeoTitleStrategy } from "./core/services/seo-title/seo-title.strategy";
import { SeoTitleStore } from "./core/services/seo-title/seo-title.store";
import { filter } from "rxjs";

registerLocaleData(en);
registerLocaleData(ru);
registerLocaleData(ro);

export const appConfig: ApplicationConfig = {
    providers: [
        TranslatePipe,
        provideCheckNoChangesConfig({ exhaustive: false }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideClientHydration(withEventReplay()),
        provideNzIcons(icons),
        provideNzI18n(en_US),
        provideNzI18n(ru_RU),
        provideNzI18n(ro_RO),
        importProvidersFrom(FormsModule),
        provideAnimationsAsync(),
        provideHttpClient(withFetch(), withInterceptors([httpRequestInterceptor])),
        provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: "top" })),

        { provide: TitleStrategy, useClass: SeoTitleStrategy },
        provideAppInitializer(() => {
            const router = inject(Router);
            const store = inject(SeoTitleStore);

            let lastPath = "";

            router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e) => {
                const path = (e as NavigationStart).url.split("?")[0];
                if (path !== lastPath) {
                    store.reset();
                }
                lastPath = path;
            });
        }),
        provideServiceWorker("ngsw-worker.js", {
            enabled: !isDevMode(),
            registrationStrategy: "registerWhenStable:30000",
        }),
        {
            provide: NZ_DATE_CONFIG,
            useValue: {
                firstDayOfWeek: 1,
            },
        },
    ],
};
